const initImageAndTextSliderWithPreviewWidget = () => {
    const imageAndTextSliderWithPreview = document.querySelector("[data-image-and-text-slider-with-preview-widget]");
    if (imageAndTextSliderWithPreview) {
        const config = new CarouselConfig();
        config.sliderSelector = "[data-main-carousel]";
        config.cellAlign = CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = true;
        config.showArrows = false;
        config.showArrows = false;
        config.showDots = false;
        config.groupCells = true;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        config.activateCustomButtons = true;
        const responsiveCarousel = new ResponsiveCarousel();
        const createdCarouselsArray = responsiveCarousel.initCarousel(config);
        //setup config for preview slider
        config.sliderSelector = "[data-preview-carousel]";
        config.activateCustomButtons = false;
        config.notDraggable = true;
        //init preview
        const createdPreviewCarouselsArray = responsiveCarousel.initCarousel(config);
        //handle custom slide selector and detects events to change preview slider
        createdCarouselsArray.forEach(carousel => {
            //handle custom slide selector
            const numbersArray = carousel.slider.closest("[data-image-and-text-slider-with-preview-widget]").querySelectorAll("[data-number]");
            numbersArray.forEach(number => {
                //when user clicks on number, slide to selected slide
                number.addEventListener("click", () => {
                    //remove active class from all others numbers
                    numbersArray.forEach(x => x.classList.remove("active"));
                    //activate visually current number
                    number.classList.add("active");
                    //get index
                    const index = number.getAttribute("data-number");
                    //navigate to slide
                    carousel.select(parseInt(index) - 1);
                });
            });
            //detects events to change preview slider and update numbers selector
            createdPreviewCarouselsArray.forEach(previewCarousel => {
                carousel.on('change', (index) => {
                    //preview slider
                    previewCarousel.select(carousel.selectedIndex);
                    //numbers selector
                    numbersArray.forEach(x => x.classList.remove("active"));
                    carousel.slider.closest("[data-image-and-text-slider-with-preview-widget]").querySelector(`[data-number="${index + 1}"]`).classList.add("active");
                });
            });
        });
    }
};
